// src/pages/Login.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../components/Input";
import Button from "../components/Button";
import { login } from "../services/auth";
import useAuth from "../hooks/useAuth";

const Login = () => {
  const [user_id, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { login: setAuth } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true); // start loading

    try {
      const data = await login({ userId: user_id, password });
      if (data.success) {
        if (data.admin) {
          setAuth(data.token, data.user);
          navigate("/dashboard");
        } else {
          alert("You are not authorised!");
        }
      } else {
        alert("wrong credentials");
      }
    } catch (err) {
      console.error("Login failed:", err);
      setError("Invalid credentials. Please try again.");
    } finally {
      setLoading(false); // stop loading
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-gray-500 to-neutral-600 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
          Login to Admin Panel
        </h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          <Input
            type="number"
            label="User Id"
            value={user_id}
            autoFocus
            onKeyDown={(e) => {
              // prevent non-numeric characters like e, +, -
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
              }
            }}
            onChange={(e) => setUserId(e.target.value)}
          />

          <Input
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && <p className="text-red-600 text-sm">{error}</p>}

          <Button type="submit" disabled={loading}>
            {loading ? "Signing In..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
